@if (route.firstChild) {
<router-outlet></router-outlet>
} @else {
<div class="application-review-container">

    <!-- View Mode Banner -->
    <div class="unassigned-banner" *ngIf="isViewMode">
        <div class="unassigned-banner-content">
            <mat-icon svgIcon="icon-info-circle" class="unassigned-info-icon"></mat-icon>
            <span class="unassigned-banner-text" *ngIf="canAssignInViewMode; else defaultViewModeText">
                <strong>Unassigned Application:</strong> You are currently viewing this lead in read-only mode. Assign
                to
                begin the review process.
            </span>
            <ng-template #defaultViewModeText>
                <span class="unassigned-banner-text">
                    <strong>View Mode:</strong> You are currently viewing this lead in read-only mode.
                </span>
            </ng-template>
        </div>

        <div class="unassigned-banner-actions" *ngIf="canAssignInViewMode">
            <app-buttons [variant]="'primary'" [label]="'Assign'" (clicked)="onAssign()">
                <mat-icon btn-icon-start svgIcon="icon-assign-person" class="assign-icon"></mat-icon>
            </app-buttons>
        </div>
    </div>

    <app-page-header [titleIcon]="false" [headerTitle]="headerTitle">

        <app-banner class="header-banner" page-header-title [variant]="customVarient" [message]="statusLabel"
            [showIcon]="false" [bgColor]="statusBgColor" [textColor]="statusTextColor"></app-banner>

        @if (showRequoteBanner) {
        <app-banner class="requote-status-banner" page-header-title variant="warning">
            <span class="requote-banner-content">
                <strong>{{ requoteBannerTitle }}:</strong> {{ requoteBannerDescription }}
                @if (isRequoteDeclined) {
                <a class="view-remarks-link" (click)="openRequoteRemarkPopup()">View Agent Remarks</a>
                }
            </span>
        </app-banner>
        }

        <div page-header-right class="review-header-right">

            <!-- View Mode -->
            <div class="view-mode-section" *ngIf="isViewMode">
                <app-banner class="header-banner icon-success" variant="success" message="View Mode"
                    iconName="icon-view-dot"></app-banner>
            </div>

            <!-- Review Mode -->
            <div class="review-mode-section" *ngIf="reviewMode && !isViewMode">
                <app-banner class="header-banner" variant="neutral" message="Review Mode"
                    iconName="icon-dot"></app-banner>
            </div>

            <ng-container *ngIf="!isViewMode">
                <span class="last-saved-text">{{ lastSaved }}</span>

                <div class="header-action-icons">
                    <mat-icon svgIcon="save-icon" class="action-icon"
                        [class.action-icon--disabled]="isOverallSaveDisabled" tabindex="0" role="button"
                        [attr.aria-disabled]="isOverallSaveDisabled" (click)="onSave()" (keydown.enter)="onSave()"
                        (keydown.space)="onSave()"></mat-icon>
                    <mat-icon svgIcon="icon-headset-support" class="action-icon" tabindex="0" role="button"
                        (click)="onSupport()" (keydown.enter)="onSupport()" (keydown.space)="onSupport()"></mat-icon>
                    <mat-icon svgIcon="message" class="action-icon" tabindex="0" role="button" (click)="onMessage()"
                        (keydown.enter)="onMessage()" (keydown.space)="onMessage()"></mat-icon>
                </div>

                <app-tooltip [text]="'All checks passed. Ready to finalise this application?'" [position]="'above'">
                    <app-buttons [variant]="'primary'" [label]="'Mark as Application Ready'"
                        [disabled]="!isApplicationReady" (clicked)="onMarkAsReady()">
                        <mat-icon btn-icon-start svgIcon="submit-icon" class="ready-icon"></mat-icon>
                    </app-buttons>
                </app-tooltip>

                <app-buttons [variant]="'secondary'"
                    [label]="selectedLeadReviewStatus === 'Unassigned' ? 'Assign Reviewer' :'Reassign Reviewer'"
                    *ngIf="userPermissionService.canShow(AppAction.LeadReviewer)" (clicked)="onReassign()">
                    <mat-icon btn-icon-start svgIcon="icon-assign-person" class="assign-icon"></mat-icon>
                </app-buttons>
            </ng-container>

        </div>

    </app-page-header>

    <div class="application-content-container">

        <section class="application-review-content">

            <!-- LEAD INFO TAB -->
            <app-lead-info [leadInfo]="leadInfoData" [selectedLead]="selectedLeadData"
                [productId]="quotePreviewProductId" [leadInfoId]="quotePreviewLeadInfoId"></app-lead-info>
            <div class="applications-details">

                <!-- Select Applicant -->
                <div class="select-applicant-section">
                    <div class="section-header">
                        <span class="section-number">1</span>
                        <span class="section-title">Select Applicant</span>
                        <span class="applicant-count">Applicants ({{ applicantTabs.length }})</span>
                    </div>
                    @if (applicantTabs.length > 0) {
                    <div class="applicant-tabs-nav">
                        <button type="button" class="applicant-nav-button applicant-nav-button--left"
                            aria-label="Previous applicant" [disabled]="!canNavigateToPreviousApplicant()"
                            (click)="onPreviousApplicant()">
                            <mat-icon svgIcon="icon-arrow-left" aria-hidden="true"></mat-icon>
                        </button>
                        <app-tabs [tabs]="applicantTabs" [selectedIndex]="applicantSelectedIndex"
                            [changeActiveIconColor]="false" [optimisticSelection]="false"
                            (tabChange)="onApplicantTabChange($event)" class="applicant-tabs"></app-tabs>
                        <button type="button" class="applicant-nav-button applicant-nav-button--right"
                            aria-label="Next applicant" [disabled]="!canNavigateToNextApplicant()"
                            (click)="onNextApplicant()">
                            <mat-icon svgIcon="icon-arrow-right" aria-hidden="true"></mat-icon>
                        </button>
                    </div>
                    } @else {
                    <div class="applicant-empty-state">
                        No applicants available.
                    </div>
                    }
                </div>

                <!-- Verify Details -->
                <div class="verify-details-section">
                    <div class="section-header">
                        <span class="section-number">2</span>
                        <span class="section-title">Verify Details</span>
                    </div>
                    <app-tabs [tabs]="verifyDetailsTabs" [selectedIndex]="verifySelectedIndex"
                        [changeActiveIconColor]="false" [optimisticSelection]="false"
                        (tabChange)="onVerifyTabChange($event)" class="verify-tabs"></app-tabs>
                    @if(verifySelectedIndex === 1) {

                    <!-- MAF SECTION -->
                    <app-maf-app-review [appReviewData]="appReviewData"
                        [selectedApplicant]="applicantTabs[applicantSelectedIndex]"
                        (mafVerificationChanged)="onMafVerificationChanged($event)"
                        (mafSharedApplicantsVerificationUpdated)="onMafSharedApplicantsVerificationUpdated($event)"
                        [isReadOnly]="isViewMode"></app-maf-app-review>
                    }

                    <app-upload-documents-preview #uploadDocumentsPreviewRef
                        [leadInfoId]="selectedLeadData?.leadInfoId || selectedLeadData?.id || ''"
                        [reviewQueueId]="selectedLeadData?.reviewQueueId || ''"
                        [mafFinalSubmissionId]="appReviewData?.mafInfo?.mafFinalSubmissionId || selectedLeadData?.mafFinalSubmissionId || ''"
                        [configurationId]="appReviewData?.mafInfo?.mafUploadedDocuments?.mafConfigurationId || appReviewData?.mafInfo?.mafConfigurationId || appReviewData?.maf?.mafConfigurationId || appReviewData?.headerSummary?.mafConfigurationId || selectedLeadData?.mafConfigurationId || ''"
                        [applicantId]="applicantTabs[applicantSelectedIndex]?.applicantId || ''"
                        [applicants]="appReviewData?.applicants || []"
                        [basicInfo]="selectedLeadData?.basicInfo || appReviewData?.basicInfo || null"
                        [leadInfo]="appReviewData?.leadInfo || selectedLeadData?.leadInfo || null"
                        [contactInfoId]="appReviewData?.leadInfo?.contactInfoId || selectedLeadData?.contactInfoId || selectedLeadData?.leadInfo?.contactInfoId || ''"
                        [mafSubmissions]="appReviewData?.mafInfo?.mafUploadedDocuments?.submissions || appReviewData?.maf?.submissions || []"
                        [isDocumentReviewed]="getSelectedApplicantDocumentReviewed()"
                        [showActionRequiredBanner]="isDocumentsTabWarning"
                        [isReadOnly]="isViewMode || !userPermissionService.canShow(AppAction.ManageDocument) || !userPermissionService.canShow(AppAction.ProcessDocumentOcr)"
                        [isSponsorSelf]="isCurrentSponsorSelf"
                        (requestRequote)="openRequestRequoteFromDocumentWarning($event)"
                        (requestRequoteApi)="requestRequoteDirectFromDocumentWarning($event)"
                        (backToReviewQueueRequested)="navigateBackToReviewQueue()"
                        (documentsFinalizedChanged)="onDocumentsFinalizedChanged($event)"
                        (reviewStatusRefreshRequested)="onDocumentReviewStatusRefreshRequested($event)"
                        [hidden]="!documentsSelected" [enableCopyMode]="isCopyModeEnabled">
                    </app-upload-documents-preview>

                    @if (verifySelectedIndex !== 1 && !documentsSelected && selectedApplicantProfileData) {
                    <app-applicant-profile [profileData]="selectedApplicantProfileData"
                        [leadInfoId]="selectedLeadData.leadInfoId" [isReadOnly]="isViewMode"
                        [enableCopyMode]="isCopyModeEnabled"
                        [finalSubmissionId]="appReviewData?.mafInfo?.mafFinalSubmissionId ?? selectedLeadData?.mafFinalSubmissionId ?? ''"
                        (isAdditionalInfoSaved)="onAdditionalInfoSaved($event)"></app-applicant-profile>
                    }

                </div>

            </div>
        </section>

        <section class="applicant-update-section">
            <app-applicant-review-summary-card
                [applicantName]="applicantTabs[applicantSelectedIndex]?.label || leadInfoData.clientName"
                [reviewedCount]="reviewedApplicantsCount" [totalApplicants]="totalApplicantsCount"
                [isCurrentApplicantReviewed]="isCurrentApplicantReviewed" [mafUploaded]="isMafVerified"
                [mandatoryDocsUploaded]="isDocumentsVerified" [extractedFieldsFinalized]="isDocumentsVerified"
                [canMarkApplicantReviewed]="isCurrentApplicantEligibleForReviewMark"
                [canProceedNextApplicant]="canProceedToNextApplicant" [isReadOnly]="isViewMode"
                (markApplicantReviewed)="onToggleApplicantReviewed()"
                (proceedNextApplicant)="onProceedToNextApplicant()">
            </app-applicant-review-summary-card>

            <app-requote-remark-card [leadInfoId]="selectedLeadData?.id || selectedLeadData?.leadInfoId || ''"
                [refreshKey]="requoteRemarkRefreshKey"></app-requote-remark-card>
        </section>
    </div>
</div>

<app-form-popup *ngIf="showSupportPopup" [config]="supportPopupConfig" [customContent]="true" [showActions]="false"
    [showCloseIcon]="true" [modalContainerClass]="'support-popup-container'" (closeModal)="closeSupportPopup()">
    <div form-popup-content class="support-popup-content">
        @if (selectedSupportAction === 'inquireDataDoc') {
        <form [formGroup]="inquiryForm" class="support-inquiry-form">
            <div class="support-form-group">
                <span class="support-form-label">Query for Agent<span class="required-mark">*</span></span>
                <textarea class="support-query-textarea" formControlName="query"
                    placeholder="Describe the data or document inquiry for the agent..."></textarea>
            </div>

            <div class="support-form-group">
                <span class="support-form-label">Attach Documents (Optional)</span>
                <app-file-upload [mode]="'inline'" [acceptedMimeTypes]="['image/jpeg','image/png','application/pdf']"
                    [acceptedExtensions]="'.jpg,.jpeg,.png,.pdf'" [maxSizeMb]="2" [multiple]="true"
                    [dropZoneHint]="'JPG, PNG, PDF • Max 2MB'" (filesChange)="onInquiryFilesSelected($event)">
                </app-file-upload>
            </div>

            <div class="support-form-group">
                <span class="support-form-label">Applicant Info<span class="required-mark">*</span></span>
                <app-dropdown formControlName="applicantInfoId" [options]="inquiryApplicantOptions" [searchFlag]="true"
                    [multiselect]="false" [placeholder]="'Choose applicant'">
                </app-dropdown>
            </div>

            <div class="support-form-group">
                <span class="support-form-label">Required doc types</span>
                <app-dropdown formControlName="documentTypeIds" [options]="inquiryDocumentTypeOptions"
                    [searchFlag]="true" [multiselect]="true" [placeholder]="'Choose required doc types'">
                </app-dropdown>
            </div>

            <div class="support-inquiry-actions">
                <app-buttons [label]="'Back'" [variant]="'secondary'" (clicked)="onBackToSupportActions()">
                </app-buttons>
                <app-buttons [label]="'Send Inquiry'" [variant]="'primary'" [disabled]="isInquirySendDisabled"
                    (clicked)="onSendInquiry()">
                </app-buttons>
            </div>
        </form>
        } @else if (selectedSupportAction === 'requestRequote') {
        <form [formGroup]="requoteForm" class="support-requote-form">
            <div class="support-form-group">
                <span class="support-form-label">Requote Reason<span class="required-mark">*</span></span>
                <textarea class="support-query-textarea" formControlName="reason"
                    placeholder="Enter the reason for requesting a requote..."></textarea>
            </div>

            <div class="support-inquiry-actions">
                <app-buttons [label]="'Back'" [variant]="'secondary'" (clicked)="onBackToSupportActions()">
                </app-buttons>
                <app-buttons [label]="'Proceed'" [variant]="'primary'" [disabled]="isRequoteProceedDisabled"
                    (clicked)="onProceedRequote()">
                </app-buttons>
            </div>
        </form>
        } @else {
        @for (supportAction of supportActions; track supportAction.action) {
        <button type="button" class="support-action-card"
            [class.support-action-card--active]="selectedSupportAction === supportAction.action"
            (click)="onSupportActionSelect(supportAction.action)">
            <span class="support-action-icon-wrap">
                <mat-icon class="support-action-icon" [svgIcon]="supportAction.iconName"></mat-icon>
            </span>
            <span class="support-action-text">
                <span class="support-action-title">{{ supportAction.title }}</span>
                <span class="support-action-description">{{ supportAction.description }}</span>
            </span>
        </button>
        }
        <div class="support-quick-actions">
            @for (quickAction of supportQuickActions; track quickAction.action) {
            <button type="button" class="support-quick-action-card"
                (click)="onSupportQuickActionSelect(quickAction.action)">
                <span class="support-quick-action-icon-wrap">
                    <mat-icon class="support-quick-action-icon" fontSet="material-icons-outlined">
                        {{ quickAction.iconName }}
                    </mat-icon>
                </span>
                <span class="support-quick-action-title">{{ quickAction.title }}</span>
            </button>
            }
        </div>
        }
    </div>
</app-form-popup>

@if (showAssignPopup || showReassignPopup) {
<app-form-popup [config]="popupConfig" (submitted)="handleReviewerPopupSubmit($event)"
    (closeModal)="closeReviewerPopup()">
</app-form-popup>
}

@if (showRemarkPopup) {
<app-form-popup class="add-remarks" [config]="remarkPopupConfig" (submitted)="handleRemarkSubmit($event)"
    (closeModal)="closeRemarkPopup()">
    <p form-popup-footer-note class="remark-popup-helper-text">
        These remarks will be attached to the lead for future reference.
    </p>
</app-form-popup>
}

@if (showRequoteRemarkPopup) {
<app-form-popup class="requote-popup" [showCloseIcon]="true" [config]="requoteRemarkPopupConfig" [customContent]="true"
    [showActions]="false" (closeModal)="closeRequoteRemarkPopup()">
    <div form-popup-content class="requote-remark-popup-content">
        <app-requote-remark-card [leadInfoId]="selectedLeadData?.id || selectedLeadData?.leadInfoId || ''"
            [refreshKey]="requoteRemarkRefreshKey"></app-requote-remark-card>
    </div>
</app-form-popup>
}

@if (showRequoteConfirmPopup) {
<app-popup-modal [width]="'500px'" [isCloseIcon]="true" [imageSrc]="images.Cancel_Logo"
    [imageClass]="'review-confirm-image'" [title]="'Confirm Requote Request'" [messageContent]="requoteConfirmMessage"
    [isHtmlContent]="true" [messageClass]="'support-requote-confirm-body'" [buttons]="requoteConfirmButtons"
    (closePopupModal)="closeRequoteConfirmPopup()">
</app-popup-modal>
}

@if (showMarkReadyConfirmPopup) {
<app-popup-modal [width]="'500px'" [isCloseIcon]="true" [imageSrc]="images.Cancel_Logo"
    [imageClass]="'review-confirm-image'" [title]="'Finalise Application Review?'"
    [messageContent]="'You are about to mark Lead ' + '<strong>' + leadInfoData.leadId + '</strong>' + ' as ready. This will lock all verified data and documents for all applicants.<br><br>This action cannot be undone. Are you sure you want to proceed?'"
    [isHtmlContent]="true" [messageClass]="'mark-ready-confirm-body'" [buttons]="markReadyConfirmButtons"
    (closePopupModal)="closeMarkAsReadyPopup()">
</app-popup-modal>
}

@if (showReopenApplicantConfirmPopup) {
<app-popup-modal [width]="'450px'" [isCloseIcon]="true" [imageSrc]="images.Cancel_Logo"
    [imageClass]="'review-confirm-image'" [title]="'Reopen Applicant Review?'"
    [messageContent]="reopenApplicantConfirmMessage" [isHtmlContent]="true"
    [messageClass]="'reopen-applicant-confirm-body'" [buttons]="reopenApplicantConfirmButtons"
    (closePopupModal)="closeReopenApplicantPopup()">
</app-popup-modal>
}

@if (contactCardDetails) {
<app-agent-contact-card [contactDetails]="contactCardDetails" [contactType]="contactCardType" [showTrigger]="false" />
}
<app-unsaved-changes-popup [show]="unsavedChangesService.showPopup"
    (stayOnPage)="unsavedChangesService.cancelNavigation()"
    (leaveWithoutSaving)="unsavedChangesService.confirmNavigation()">
</app-unsaved-changes-popup>
}